import axios from 'axios';
import { useQuery } from '@tanstack/react-query';

export const useCalendarEventsDates = () => {
  const calendarId = process.env.NEXT_PUBLIC_GOOGLE_CALENDER_ID;
  const apiKey = process.env.NEXT_PUBLIC_GOOGLE_CALENDER_KEY;

  const { data: events, isError } = useQuery(['calendarEvents'], () =>
    axios.get(
      `https://www.googleapis.com/calendar/v3/calendars/${calendarId}/events`,
      { params: { key: apiKey } }
    )
  );

  return { events: events?.data || [], isError };
};
